// extracted by mini-css-extract-plugin
module.exports = {"dpu-detail-T":"T_dpu-detail-T__t3MNk"};